import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";
import { useNavigate } from "react-router-dom";

const RaisonsPublish = () => {
  const nav = useNavigate();
  return (
    <StyledRaisonsPublish>
      <h3>Si to lé up voici pourquoi publier sur Emoh Up </h3>
      <ul>
        <li>🌎 Plateforme 100% dédiée à la Guyane - la référence locale</li>
        <li>📢 Campagnes actives tous les mois sur les réseaux</li>
        <li>🚀 Visibilité locale maximale auprès d'un public ciblé</li>
        <li>🆕 Publication simple sans inscription</li>
        <li>📱 Interface simple, moderne et adaptée mobile</li>
        <li>👥 Ouvert aux particuliers & professionnels</li>
      </ul>
      <strong className="str-begin" onClick={() => nav("/post")}>
        COMMENCER
      </strong>
    </StyledRaisonsPublish>
  );
};

export default RaisonsPublish;

const StyledRaisonsPublish = styled.section`
  padding: 0px 20px;
  width: 60%;
  margin: 10px auto;
  h3 {
    text-align: center;
    width: 100%;
    font-size: 2.5em;
    color: ${COLORS.border_and_text_blue};
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 10px auto;
    li {
      background: ${COLORS.main};
      margin: 15px 10px;
      font-size: 1.3em;
      border-radius: 5px;
      border: solid 1px ${COLORS.border_and_text_blue};
      border-left: solid 4px ${COLORS.green};
      padding: 10px;
      color: ${COLORS.white};
    }
  }
  .str-begin {
    margin-left: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 10px 20px;
    color: white;
    background: ${COLORS.orange_new};
    cursor: pointer;
    font-size: 1.1em;
  }
  @media screen and (max-width: 445px) {
    width: 100%;
    h3 {
      font-size: 1.5em;
    }
    ul {
      li {
        font-size: 1em;
      }
    }
  }
`;
